export function register(params) {
    return window.axios.post("api/cuser/register", params)
}
export function login(params) {
    return window.axios.post("api/cuser/login", params)
}
export function getImageCode() {
    return window.axios.post("api/cuser/getImageCode", {})
}
export function sendCode(params) {
    return window.axios.post("api/cuser/send", params)
}
export function phoneLogin(params) {
    return window.axios.post("api/cuser/phoneLogin", params)
}
export function verifyPhoneAndAccount(params) {
    return window.axios.post("api/cuser/verifyPhoneAndAccount", params)
}
export function updatePasswordWithAccountAndPassword(params) {
    return window.axios.post("api/cuser/updatePasswordWithAccountAndPassword", params)
}
